import { useEffect, useState } from "react";
import { GetTransactionTypes, Updateinventry } from "../../services/inventory";
import { GetAllProduct } from "../../services/productService";
import CDropdown from "../../common/CDropdown";
import CommonMessage from "../../common/CommonMessage";

const UpdateInventory = () => {
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [transactionTypes, setTransactionTypes] = useState([]);

    const [formData, setFormData] = useState({
        productId: "",
        quantity: "",
        transactionType: "",
        referenceNo: "",
        remarks: ""
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {

            const [productRes, transactionRes] = await Promise.all([
                GetAllProduct(),
                GetTransactionTypes()
            ]);

            if (productRes?.success) {
                setProducts(productRes.data);
            }

            if (transactionRes?.success) {
                setTransactionTypes(transactionRes.data);
            }

        } catch (error) {
            console.log(error);
        }
    };

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    const validate = () => {

        let validationErrors = {};

        if (!formData.productId)
            validationErrors.productId = "Product is required.";

        if (!formData.quantity)
            validationErrors.quantity = "Quantity is required.";

        if (Number(formData.quantity) <= 0)
            validationErrors.quantity = "Quantity must be greater than 0.";

        if (!formData.transactionType)
            validationErrors.transactionType = "Transaction Type is required.";

        setErrors(validationErrors);

        return Object.keys(validationErrors).length === 0;
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validate())
            return;

        try {

            setLoading(true);

            const payload = {
                productId: Number(formData.productId),
                quantity: Number(formData.quantity),
                transactionType: Number(formData.transactionType),
                referenceNo: formData.referenceNo,
                remarks: formData.remarks
            };

            const response = await Updateinventry(payload);

            if (response?.success) {

                setMessage(response.message);

                setFormData({
                    productId: "",
                    quantity: "",
                    transactionType: "",
                    referenceNo: "",
                    remarks: ""
                });

            } else {

                setMessage(response.message);
            }

        } catch (error) {

            console.log(error);
            setMessage("Something went wrong.");

        } finally {

            setLoading(false);

        }
    };

    return (
        <>
            {message && <CommonMessage text={message} />}
            <div className="container mt-4">
                <div className="card">
                    <div className="card-header">
                        <h4>Update Inventory</h4>
                    </div>

                    <div className="card-body">

                        <form onSubmit={handleSubmit}>

                            <div className="mb-3">
                                <label>Product</label>
                                <CDropdown
                                    name="productId"
                                    value={formData.productId}
                                    options={products}
                                    optionLabel="name"
                                    optionValue="id"
                                    onChange={handleChange}
                                    firstOption="Select Product"
                                />
                                <small className="text-danger">
                                    {errors.productId}
                                </small>
                            </div>

                            <div className="mb-3">

                                <label>Transaction Type</label>
                                <CDropdown
                                    name="transactionType"
                                    value={formData.transactionType}
                                    options={transactionTypes}
                                    optionLabel="name"
                                    optionValue="id"
                                    onChange={handleChange}
                                    firstOption="Select TransactionTypes"
                                />
                                <small className="text-danger">
                                    {errors.transactionType}
                                </small>

                            </div>

                            <div className="mb-3">

                                <label>Quantity</label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleChange}
                                />

                                <small className="text-danger">
                                    {errors.quantity}
                                </small>

                            </div>

                            <div className="mb-3">

                                <label>Reference No</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="referenceNo"
                                    value={formData.referenceNo}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="mb-3">

                                <label>Remarks</label>

                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleChange}
                                />

                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Update Inventory"}
                            </button>

                        </form>

                    </div>

                </div>

            </div>
        </>
    );
};

export default UpdateInventory;